export default () => ({
  subjects: [],
  subject: {},
  classBookUrl: null,
  lastLesson: null,
})
